import { Box, Button, TextField, Typography } from '@mui/material';
import { apiUrlPrefix } from '../../../../config';
import Cookies from 'js-cookie'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@tanstack/react-query';
import React from 'react';

const ChangePassword = ({ error, setError, setPasswordChanged, selectedItem, nonSelectedItem, selected, setSelected }) => {

  const changePassword = async ({ oldPassword, newPassword }) => {
    const response = await fetch(`${apiUrlPrefix}MongoDb/ChangePassword`, {
      method: "POST",
      credentials: "include",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Id: localStorage.getItem('userId'),
        OldPassword: oldPassword,
        NewPassword: newPassword
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      setError(errorData);
      throw new Error(errorData.message || "Failed to change password");
    }
    setError("");

    setPasswordChanged(true);
    return await response.json(); // MUST return for onSuccess to work!
  };

  const formik = useFormik({
    initialValues: {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required('Required'),
      newPassword: Yup.string().min(6, 'Too short').required('Required'),
      confirmNewPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match') // Yup handles the drama for you
        .required('Required'),
    }),
    onSubmit: (values) => {
      changePasswordMutation.mutate(values);
    },
  });

  const changePasswordMutation = useMutation({
    mutationFn: changePassword,
    onSuccess: (data) => {
      if (data) {
        return data;
      } else {
        throw new Error('Unexpected response structure');
      }
    },
    onError: (error) => {
      setError(error.message); // Set the error message
    },
  });
  return (
    <Box className={selected === 2 ? '' : 'hidden'} component="form" onSubmit={formik.handleSubmit} sx={{ width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <>
        <Typography variant="h6" sx={{ cursor: 'pointer' }}>Change Password:</Typography>

        <Typography fontSize={'12px'} sx={{ color: 'red' }}>{error}</Typography>

        <TextField
          label="Old Password"
          type="password"
          name="oldPassword"
          fullWidth
          value={formik.values.oldPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.oldPassword && !!formik.errors.oldPassword}
          helperText={formik.touched.oldPassword && formik.errors.oldPassword}
        />

        <TextField
          label="New Password"
          type="password"
          name="newPassword"
          fullWidth
          value={formik.values.newPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.newPassword && !!formik.errors.newPassword}
          helperText={formik.touched.newPassword && formik.errors.newPassword}
        />

        <TextField
          label="Confirm New Password"
          type="password"
          name="confirmNewPassword"
          fullWidth
          value={formik.values.confirmNewPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.confirmNewPassword && !!formik.errors.confirmNewPassword}
          helperText={formik.touched.confirmNewPassword && formik.errors.confirmNewPassword}
        />

        <Button
          type="submit"
          variant="contained"
          disabled={changePasswordMutation.isPending}
        >
          {changePasswordMutation.isPending ? 'Processing...' : 'Update Password'}
        </Button>

        <Button color="inherit">Cancel</Button>
      </>
    </Box>
  )
};

export default ChangePassword;